import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { translate } from "../../../config/translator";
import { ClavaContext } from "../../../config/contexts";

type BackButtonProps = {
  to?: string;
  onClick?: () => void;
  absolute?: boolean;
  showLabel?: boolean;
};

const BackButton: React.FC<BackButtonProps> = ({
  to,
  onClick,
  absolute = true,
  showLabel = true,
}) => {
  const { l } = useContext(ClavaContext);
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  const baseClassName = `inline-flex items-center gap-2 ${absolute ? "absolute top-3 left-3" : ""}`;
  const iconClassName = "w-6 h-6 shrink-0 aspect-square text-font-600 dark:text-font-600-dark";
  const labelClassName = "text-xs font-medium text-font-600 dark:text-font-600-dark";

  const content = (
    <>
      <FontAwesomeIcon icon={faChevronLeft} className={iconClassName} />
      {showLabel && <span className={labelClassName}>{translate("back", l)}</span>}
    </>
  );

  if (to) {
    return (
      <NavLink to={to} className={baseClassName} aria-label={translate("back", l)}>
        {content}
      </NavLink>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={baseClassName}
      aria-label={translate("back", l)}
    >
      {content}
    </button>
  );
};

export default BackButton;



